import React, { useEffect, useState } from "react";
import formatDateAndTime from "../../common/formatDateAndTime";

const Timeline = ({ summaryDetails }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [timelineData, setTimeLineData] = useState(null);

  const getTheTimelineData = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookinghistories?limit=1000&bookingId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setTimeLineData(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };

  useEffect(() => {
    if (summaryDetails?.id) {
      getTheTimelineData(summaryDetails?.id);
    }
  }, [summaryDetails]);

  return (
    <div>
      <div className="px-6 py-6 bg-white rounded-xl shadow-md">
        <h2 className="text-2xl font-bold text-gray-800 mb-8">
          ⏱ Booking Timeline
        </h2>

        <div className="relative border-l-2 border-gray-300 ml-4 space-y-10">
          {timelineData ? (
            timelineData.map((item, index) => (
              <div key={index} className="relative pl-8">
                <div className="absolute -left-[10px] top-1.5 w-4 h-4 bg-blue-500 rounded-full border-2 border-white shadow" />

                <div>
                  <div className="text-sm text-gray-500">
                    {formatDateAndTime(item.generatedOn)}
                  </div>
                  <div className="text-lg font-semibold text-gray-800">
                    {item.action}
                  </div>
                  <div className="mt-1 text-gray-700 text-sm space-y-1">
                    {item.agentName}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <>
              <h1>No Timeline datas found</h1>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Timeline;
